const navBarOptions = [
  {
    option: 'Sobre mim',
    href: '#about',
  },
  {
    option: 'Habilidades',
    href: '#skills',
  },
  {
    option: 'Vou aprender',
    href: '#to-learn',
  },
  {
    option: 'Projetos',
    href: '#projects',
  },
  {
    option: 'Contato',
    href: '#contact',
  },
];

export default navBarOptions;
